export default function (state, action) {
  const { type, payload } = action;
  switch (type) {
    case 'CHANGE_FIELD':
      return { ...state, values: { ...state.values, ...payload } };
    case 'ERROR':
      return { ...state, error: payload };
    case 'LOAD':
      return { ...state, values: payload };
    default:
      return state;
  }
}
